'use strict';

import PhotoSwipeLightbox from './photoswipe-lightbox.esm.min.js';
import Photoswipe from './photoswipe.esm.min.js';

class ZoomAction extends HTMLElement {
  constructor() {
    super();
    this.type = this.dataset.type || 'no_zoom';
    this.zoomOption = this.dataset.zoomOption || 'external';
    this.lightbox = null;
    this.drifts = [];

    this.mql = window.matchMedia('(min-width: 768px)');
    this.handleResponsive = this.responsive.bind(this);
  }

  connectedCallback() {
    if (this.type === 'no_zoom') return;

    this.mql.addEventListener('change', this.handleResponsive);
    window.addEventListener('load', this.handleResponsive);

    this.responsive(this.mql);
  }

  async initLightBox() {
    if (this.lightbox) {
      this.lightbox.destroy();
      this.lightbox = null;
    }

    const items = [];
    const triggers = [];
    const galleryContainer = this.querySelector('.media-main-swiper') || this;

    galleryContainer.querySelectorAll(
      'a.media-gallery__image, .media-gallery__local-video, .media-gallery__external-video'
    ).forEach((el) => {
      let item = null;
      let triggerEl = el;

      if (el.matches('a.media-gallery__image')) {
        const img = el.querySelector('img');
        item = {
          src: el.href,
          msrc: img?.getAttribute('src'),
          w: parseInt(el.getAttribute('data-pswp-width'), 10) || img?.width || 1000,
          h: parseInt(el.getAttribute('data-pswp-height'), 10) || img?.height || 1000,
          el: el,
          type: 'image'
        };
      } else if (el.matches('.media-gallery__local-video')) {
        const video = el.querySelector('video');
        const posterImg = el.querySelector('img');
        const videoSrc = video?.getAttribute('src') || '';
        const posterSrc = video?.getAttribute('poster') || posterImg?.getAttribute('src') || '';
        item = {
          html: `<video controls playsinline loop muted poster="${posterSrc}" style="max-width:100%;max-height:100%;object-fit:contain;" crossorigin="anonymous"><source src="${videoSrc}" type="video/mp4"></video>`,
          w: parseInt(video?.getAttribute('width'), 10) || posterImg?.width || 1080,
          h: parseInt(video?.getAttribute('height'), 10) || posterImg?.height || 1920,
          el: posterImg || el,
          type: 'video'
        };
      } else if (el.matches('.media-gallery__external-video')) {
        const iframe = el.querySelector('iframe');
        const posterImg = el.querySelector('img');
        const iframeSrc = iframe?.getAttribute('src') || '';
        item = {
          html: `<iframe src="${iframeSrc}" style="width:100%;height:100%;border:none;" allowfullscreen></iframe>`,
          w: posterImg?.width || 1080,
          h: posterImg?.height || 720,
          el: posterImg || el,
          type: 'video'
        };
      }

      if (item) {
        const index = items.length;
        items.push(item);
        triggerEl.setAttribute('data-pswp-index', index);
        triggers.push(triggerEl);
      }
    });

    if (items.length === 0) return;

    this.lightbox = new PhotoSwipeLightbox({
      dataSource: items,
      pswpModule: () => Photoswipe,
      counter: false,
      zoom: false,
      preloader: false,
      arrowPrev: false,
      arrowNext: false,
      close: false,
      loop: false,
      bgOpacity: 1
    });

    // Inline SVG definitions mapped from sprite-svg.liquid
    const closeSVG = `<svg style="pointer-events: none;" width="13" height="14" viewBox="0 0 13 13" fill="none" class="transition" xmlns="http://www.w3.org/2000/svg"><path d="M0.282609 2.06784C0.0942029 1.89363 0 1.68314 0 1.43635C0 1.17504 0.0942029 0.950028 0.282609 0.761307C0.456522 0.587102 0.673913 0.5 0.934783 0.5C1.19565 0.5 1.41304 0.587102 1.58696 0.761307L6.5 5.68258L11.413 0.761307C11.587 0.587102 11.8043 0.5 12.0652 0.5C12.3261 0.5 12.5435 0.587102 12.7174 0.761307C12.9058 0.950028 13 1.17504 13 1.43635C13 1.68314 12.9058 1.89363 12.7174 2.06784L7.80435 6.98911L12.7174 11.9104C12.9058 12.0991 13 12.3241 13 12.5854C13 12.8322 12.9058 13.0427 12.7174 13.2169C12.5435 13.4056 12.3261 13.5 12.0652 13.5C11.8043 13.5 11.587 13.4056 11.413 13.2169L6.5 8.31742L1.58696 13.2169C1.41304 13.4056 1.19565 13.5 0.934783 13.5C0.673913 13.5 0.456522 13.4056 0.282609 13.2169C0.0942029 13.0427 0 12.8322 0 12.5854C0 12.3241 0.0942029 12.0991 0.282609 11.9104L5.19565 6.98911L0.282609 2.06784Z" fill="currentColor"/></svg>`;
    const nextSVG = `<svg style="pointer-events: none;" width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M1.278 10.721a.688.688 0 0 1-.528.229.688.688 0 0 1-.527-.229.669.669 0 0 1-.229-.51c0-.21.077-.392.229-.544l3.973-3.973L.223 1.721a.669.669 0 0 1-.229-.51c0-.21.077-.392.229-.544C.363.527.539.456.75.456c.211 0 .387.07.528.21l4.5 4.5a.744.744 0 0 1 .228.546c0 .199-.076.369-.228.51l-4.5 4.5Z"/></svg>`;
    const prevSVG = `<svg style="pointer-events: none;" width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.7193 10.7605C4.85965 10.9202 5.03509 11 5.24561 11C5.45614 11 5.63158 10.9202 5.77193 10.7605C5.92398 10.6131 6 10.435 6 10.2261C6 10.005 5.92398 9.81463 5.77193 9.65494L1.80702 5.49079L5.77193 1.32663C5.92398 1.17923 6 1.00112 6 0.792295C6 0.571189 5.92398 0.380793 5.77193 0.221106C5.63158 0.0737018 5.45614 0 5.24561 0C5.03509 0 4.85965 0.0737018 4.7193 0.221106L0.22807 4.93802C0.0760236 5.09771 0 5.28811 0 5.50921C0 5.71803 0.0760236 5.89615 0.22807 6.04355L4.7193 10.7605Z" fill="currentColor"/></svg>`;
    
    let zoomBtnEl = null;
    let isZoomedIn = false;
    const zoomInSVG = `<svg style="pointer-events: none;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>`;
    const zoomOutSVG = `<svg style="pointer-events: none;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>`;

    this.lightbox.on('uiRegister', () => {
      const { pswp } = this.lightbox;

      pswp?.ui.registerElement({
        name: 'bls--close',
        tagName: 'button',
        className: 'pswp__button',
        html: closeSVG,
        onInit: (el, pswpInstance) => {
          const closeAction = (e) => {
            if (e.cancelable) e.preventDefault();
            e.stopPropagation();
            pswpInstance.close();
          };
          el.addEventListener('click', closeAction);
          el.addEventListener('touchend', closeAction, { passive: false });
        },
      });

      pswp?.ui.registerElement({
        name: 'bls--zoom',
        tagName: 'button',
        className: 'pswp__button',
        order: 2,
        html: `${zoomInSVG}`,
        onInit: (el, pswpInstance) => {
          zoomBtnEl = el;
          const zoomAction = (e) => {
            if (e.cancelable) e.preventDefault();
            e.stopPropagation();
            pswpInstance.toggleZoom();
            isZoomedIn = !isZoomedIn;
            zoomBtnEl.innerHTML = isZoomedIn ? zoomOutSVG : zoomInSVG;
          };
          el.addEventListener('click', zoomAction);
          el.addEventListener('touchend', zoomAction, { passive: false });
        }
      });

      pswp?.ui.registerElement({
        name: 'bottomBar',
        className: 'pswp__bottom-bar',
        appendTo: 'wrapper',
        onInit: (el, pswpInstance) => {
          const next = document.createElement('button');
          next.type = 'button';
          next.className = 'pswp__button pswp__button-next';
          next.innerHTML = nextSVG;
          next.onclick = () => pswpInstance.next();
          el.appendChild(next);

          const counter = document.createElement('span');
          counter.className = 'pswp__counter';
          pswpInstance.on('change', () => {
            counter.innerText = `${pswpInstance.currIndex + 1}${pswpInstance.options.indexIndicatorSep}${pswpInstance.getNumItems()}`;
          });
          el.appendChild(counter);

          const prev = document.createElement('button');
          prev.type = 'button';
          prev.className = 'pswp__button pswp__button-prev';
          prev.innerHTML = prevSVG;
          prev.onclick = () => pswpInstance.prev();
          el.appendChild(prev);
        },
      });
    });

    this.lightbox.on('open', () => {
      document.documentElement.classList.add('pswp-open');
    });

    this.lightbox.on('close', () => {
      document.documentElement.classList.remove('pswp-open');
      isZoomedIn = false;
      if (zoomBtnEl) zoomBtnEl.innerHTML = zoomInSVG;

      const currVideo = this.lightbox.pswp?.currSlide?.container?.querySelector('video, iframe');
      if (currVideo?.tagName === 'VIDEO') {
        currVideo.pause();
      }

      setTimeout(() => {
        const index = this.lightbox.pswp?.currIndex;
        const swiper = this.closest('media-gallery')?.querySelector('.swiper')?.swiper;
        if (index != null && swiper) {
          swiper.slideTo(index, 0, false);
        }
      }, 100);
    });

    this.lightbox.on('change', () => {
      isZoomedIn = false;
      const currSlide = this.lightbox.pswp?.currSlide;
      const isVideo = currSlide?.data?.type === 'video';

      if (zoomBtnEl) {
        zoomBtnEl.style.display = isVideo ? 'none' : '';
        if (!isVideo) zoomBtnEl.innerHTML = zoomInSVG;
      }

      setTimeout(() => {
        const video = currSlide?.container?.querySelector('video');
        if (video) {
          video.play().catch(() => {});
        }
      }, 100);
    });

    this.lightbox.init();

    triggers.forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        const index = parseInt(el.getAttribute('data-pswp-index'), 10);
        if (!isNaN(index)) {
          this.lightbox.loadAndOpen(index);
        }
      });
    });

    this.querySelectorAll('.zoom_light_box').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const container = btn.closest('[data-pswp-index]');
        if (container) {
          const index = parseInt(container.getAttribute('data-pswp-index'), 10);
          if (!isNaN(index)) {
            this.lightbox.loadAndOpen(index);
          }
        }
      });
    });
  }

  initDrift() {
    if (this.drifts.length > 0) return;

    const allTriggers = this.querySelectorAll('.drift-trigger');
    const paneContainer = this.closest('.sec__featured-product')?.querySelector('.zoom-external-area');

    if (allTriggers.length !== 0) {
      allTriggers.forEach((trigger) => {
        const inlineContainer = trigger.closest('[data-pane-container]');
        const isInner2 = this.zoomOption === 'inner-2';
        const isExternal = this.zoomOption === 'external';

        this.drifts.push(new Drift(trigger, {
          inlinePane: isInner2 ? true : this.zoomOption,
          zoomFactor: isInner2 ? 3 : 5,
          containInline: isInner2 ? paneContainer : !!paneContainer,
          paneContainer: (isInner2 || isExternal) ? paneContainer : inlineContainer,
          hoverBoundingBox: isExternal,
          onShow: () => inlineContainer?.classList.add('relative'),
          onHide: () => inlineContainer?.classList.remove('relative'),
        }));
      });
    }
  }

  responsive(e) {
    const isDesktop = e.matches !== undefined ? e.matches : window.innerWidth >= 768;

    if (isDesktop) {
      if (this.type === 'open_lightbox') {
        this.initLightBox();
      } else {
        if (this.lightbox !== null) {
          this.lightbox.destroy();
          this.lightbox = null;
        }
        this.initDrift();
      }
    } else {
      if (this.type !== 'open_lightbox') {
        if (this.drifts.length > 0) {
          this.drifts.forEach(drift => drift.destroy());
          this.drifts = [];
        }
        this.initLightBox();
      } else {
        this.initLightBox();
      }
    }
    this.updateSwiper();
  }

  updateSwiper() {
    if (typeof Swiper !== 'undefined') {
      const thumbSlide = this.querySelector('.thumbnail-slide');
      if (thumbSlide && thumbSlide.swiper) {
        thumbSlide.swiper.update();
      }
    }
  }

  disconnectedCallback() {
    this.mql.removeEventListener('change', this.handleResponsive);
    window.removeEventListener('load', this.handleResponsive);

    if (this.lightbox) this.lightbox.destroy();
    if (this.drifts.length > 0) this.drifts.forEach(d => d.destroy());
  }
}

customElements.define('zoom-action', ZoomAction);

document.addEventListener('click', function (e) {
  const anchor = e.target.closest('a.media-gallery__image');
  if (anchor) e.preventDefault();
});